export class ListaPreciosVentaDetalle{

	public SALES_PRICE_LIST_DETAIL_ID: number;
	public ITEM_ID: number;
	public PRICE_FACTOR: number;
	public INITIAL_RANGE: number;
	public FINAL_RANGE: number;
	public ITEM_FAMILY_ID: number;
	public ITEM_FAMILY_ALL: boolean;
	public ITEM_SUBFAMILY_ID: number;
	public ITEM_SUBFAMILY_ALL: boolean;
	public ITEM_ALL: boolean;
	public SALES_PRICE_LIST_GENERAL_ID: number;

	// Utilizados en la pantalla lista-precios-agregar-editar
	public LISTA_FAMILIAS: any[];
	public LISTA_SUBFAMILIAS: any[];
	public LISTA_PRODUCTOS: any[];
	public LISTA_PRODUCTOS_FILTRADA: any[];
	public LISTA_PRODUCTOS_FILTER: string;
	public IDENTIFICADOR_ESCALA: number;

	public itemsShow: number;

	public arrayFilteredProd: any;
	public filteredItemsShow: number;
	public isFilteredProd: boolean;

	constructor(){
		this.SALES_PRICE_LIST_DETAIL_ID = null;
		this.ITEM_ID = null;
		this.PRICE_FACTOR = null;
		this.INITIAL_RANGE = null;
		this.FINAL_RANGE = null;
		this.ITEM_FAMILY_ID = null;
		this.ITEM_FAMILY_ALL = null;
		this.ITEM_SUBFAMILY_ID = null;
		this.ITEM_SUBFAMILY_ALL = null;
		this.ITEM_ALL = null;
		this.SALES_PRICE_LIST_GENERAL_ID = null;

		this.LISTA_FAMILIAS = [];
		this.LISTA_SUBFAMILIAS = [];
		this.LISTA_PRODUCTOS = [];
		this.LISTA_PRODUCTOS_FILTRADA = [];
		this.LISTA_PRODUCTOS_FILTER = null;
		this.IDENTIFICADOR_ESCALA = null;

		this.itemsShow = null;
	}

}


// WEBPACK FOOTER //
// ./src/app/models/ListaPreciosVentaDetalle.ts